import {
Component,
Inject,
signal,
ViewChild,
ViewContainerRef,
WritableSignal
} from '@angular/core';
import { AuthConfig,OAuthService } from 'angular-oauth2-oidc';
import { BreadcrumbService } from 'ng-breadcrumb';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import {
ICorrFilterService,
IErrorMessage,
IErrorService,
ILogService,
IRepositoryService,
} from './services/i';

import { MatButton,MatIconButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { filter,switchMap,tap } from 'rxjs/operators';
import {
AuthenticationService,
AuthenticationServiceToken,
CorrFilterServiceToken,
ErrorServiceToken,
LogServiceToken,
RepositoryServiceToken,
ScrollService,
ScrollServiceToken,
} from './services';
import { CommunityAuthService } from './services/community-auth.service';
import { CorrCountViewModel,UserViewModel } from './view-models';
import { CorrCountFilterViewModel } from './view-models/filters';
import { IdentityClaimsModel } from './view-models/identity-claims.model';

@Component({
  selector: '[app-root]',
  host: {
    // '(window:keydown)' : 'oauthService.bump()',
    // '(window.mousemove)' : 'oauthService.bump()'
  },
  imports: [
    MatButton,
    MatIconButton,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    RouterModule,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
})
export class AppComponent {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public user: UserViewModel;
  public filterNames: string[];
  public title = 'CorTrack';
  public userFullName: WritableSignal<string> = signal('');
  constructor(
    @Inject(AuthenticationServiceToken)
    public authService: AuthenticationService,
    public commAuthService: CommunityAuthService,
    @Inject(RepositoryServiceToken) protected repo: IRepositoryService,
    @Inject(ErrorServiceToken) protected errors: IErrorService,
    @Inject(LogServiceToken) protected log: ILogService,
    @Inject(CorrFilterServiceToken) protected corrFilterSvc: ICorrFilterService,
    @Inject(ScrollServiceToken) protected scroll: ScrollService,
    @Inject('authConfig') protected authConfig: AuthConfig,
    protected breadcrumbService: BreadcrumbService,
    protected oauthService: OAuthService,
    protected toastr: ToastrService,
    protected vcr: ViewContainerRef
  ) {
    this.oauthService.configure(authConfig);
    breadcrumbService.addCallbackForRouteRegex(
      '#.*$',
      path => path.split('#')[0]
    );
    breadcrumbService.addCallbackForRouteRegex('\%[0-9]{2}', path =>
      decodeURIComponent(path)
    );
    breadcrumbService.addCallbackForRouteRegex(
      '^.*[?].*$',
      path => path.split('?')[0]
    );
    breadcrumbService.hideRouteRegex('\/choose.*');
    breadcrumbService.hideRouteRegex('\/choose\/user.*');
    this.filterNames = this.corrFilterSvc.getAvailableFilterNames();
    this.corrFilterSvc.updates.subscribe(() => {
      this.filterNames = this.corrFilterSvc.getAvailableFilterNames();
    });
    if (this.authService.isAuthenticated) {
      // console.log('user is', this.authService.identityClaims);
      // console.log(authService);
      this.user = this.user ?? new UserViewModel();
      const tempIC: IdentityClaimsModel = this.authService
        .identityClaims as IdentityClaimsModel;
      this.user.First = tempIC.given_name ?? '';
      this.user.Last = tempIC.family_name ?? '';
      this.user.HawkId = tempIC.uiowahawkid ?? '';
      this.user.Email = tempIC.email ?? '';
      this.userFullName.set(`${this.authService.identityClaims.Name}`);
      // console.log('user info', this.user);
      const cfilter = new CorrCountFilterViewModel();
      cfilter.Filters = this.corrFilterSvc
        .getAvailableFilterNames()
        .map(f => this.corrFilterSvc.getFilter(f));
      cfilter.Filters.unshift(this.corrFilterSvc.getFilter('awaiting-review'));
      this.repo
        .Page(CorrCountViewModel, cfilter)
        .toPromise()
        .then(() => {});
    }

    from(this.commAuthService.runInitialLoginSequence())
      .pipe(
        switchMap(_ => this.commAuthService.isDoneLoading$),
        filter(isDone => isDone),
        switchMap(_ => this.commAuthService.isAuthenticated$),
        tap(
          async isAuth => {
            const key = this.commAuthService.actualUsername;
            if (isAuth && typeof key !== 'undefined' && key !== null) {
              // console.log('running Lookup with ', key);
              this.user = await repo
                .Lookup(UserViewModel, this.commAuthService.actualUsername)
                .toPromise();
              this.authService.setUserInfo(this.user);
            } else {
              this.log.warn('Not authenticated.');
            }
          },
          err => console.error(err)
        )
      )
      .subscribe();

    this.errors.subscribeAll(this.unhandledGlobalErrors.bind(this));
  }

  public removeFilter(name: string) {
    this.corrFilterSvc.removeFilter(name);
  }

  private unhandledGlobalErrors(payload: IErrorMessage) {
    console.error(payload);
    this.toastr.error(payload.message, `Error ${payload.type}`);
  }

  someMethod() {
    this.trigger.openMenu();
  }

  login(): void {
    this.authService.beginLoginFlow();
  }
  async logout() {
    await this.authService.logout();
  }

  onScroll($event) {
    this.scroll.scroll($event);
  }
}
